function getBiCallback(key) {
  const { children, _rcProps } = this.props;
  return children?.props.helpers?.[key] || _rcProps?.helpers?.[key];
}
export {
  getBiCallback
};
//# sourceMappingURL=getBiCallbacks.js.map
